import * as types from "../../types/stores.types";

export const actionChangeStatusShowModalInvitation = (status_show_modal) => ({
    type: types.CHANGE_STATUS_SHOW_MODAL_INVITATION, payload: {status_show_modal}
});